import React from 'react';
import { render } from '@testing-library/react';
import userEvent from '@testing-library/user-event';
import { Radio } from './Radio';

describe('Radio', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	const user = userEvent.setup();

	it('should be checked on click', async () => {
		const { getByLabelText } = render(<Radio label="Label" />);
		const radio = getByLabelText('Label') as HTMLInputElement;
		expect(radio.checked).toEqual(false);
		await user.click(radio);
		expect(radio.checked).toEqual(true);
	});

	it('should return object on change', async () => {
		const onChangeTest = jest.fn();
		const { getByLabelText } = render(
			<Radio onChange={onChangeTest} value="test" label="Label" />
		);
		const radio = getByLabelText('Label') as HTMLInputElement;
		await user.click(radio);
		expect(onChangeTest).toBeCalledWith('test', expect.any(Object));
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Radio label="Label" data-auto-sel="automation-selector" />
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
